<template>
  <div class="panel">
    <div class="head">
      <slot name="headContent">
        <h3 v-if="backHref" class="back-btn" @click="goback">
          <span class="icon-back"></span>
        </h3>
        <div v-if="title" class="head-title">
          {{ title }}
        </div>
      </slot>
    </div>
    <div class="head-split"></div>
    <div class="body">
      <slot name="bodyContent"></slot>
    </div>
    <div class="footer">
      <slot name="footerContent"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BaseJinnangPanel',
  props: {
    title: {
      type: String,
      require: true
    },
    backHref: {
      type: String,
      require: false
    }
  },
  methods: {
    goback() {
      if (this.backHref) {
        this.$router.push(this.backHref)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.panel {
  padding: 0px 50px 50px 50px;
}

.head {
  display: flex;
  align-items: center;
  height: 75px;
}

.head-split {
  height: 1px;
  background-color: #ebebeb;
}

.body {
  padding-top: 30px;
}

.head-title {
  font-family: MicrosoftYaHei;
  font-size: 20px;
  font-weight: bold;
  font-stretch: normal;
  line-height: 20px;
  letter-spacing: 0px;
  color: #262626;
}

.back-btn {
  padding-top: 24px;
  font-size: 16px;
  height: 50px;
  font-weight: bold;
  font-stretch: normal;
  line-height: 20px;
  letter-spacing: 1px;
  color: #262626;
  cursor: pointer;
}

.icon-back {
  position: relative;
  display: inline-block;
  width: 18px;
  height: 2px;
  margin-right: 10px;
  background-color: #a3a29e;

  &::before {
    content: '';
    position: absolute;
    left: 0;
    top: 20%;
    margin-top: -9px;
    width: 8px;
    height: 8px;
    border-left: 2px solid #a3a29e;
    border-bottom: 2px solid #a3a29e;
    transform: rotate(45deg);
    transform-origin: 0 100%;
  }
}
</style>
